import {Component, OnDestroy, OnInit} from '@angular/core';
import {NetworkService} from "../../../services/network.service";
import {Cest} from '../../../model/cest.model';
import {ActivatedRoute ,Router} from "@angular/router";
import {getUrlImplante,URL_BASE} from "../../../controller/staticValues";
import {MessageService} from "primeng/api";
import { Subscription } from 'rxjs'
import {Formulario} from "../../../controller/Formulario";
import {DadosDefaultService} from "../../../services/dados-default.service";
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Util } from 'src/app/controller/Util';

@Component({
    selector: 'app-editar-cest',
    templateUrl: './editar-cest.component.html',
    styleUrls: ['./editar-cest.component.css'],
    standalone: false
})
export class EditarCestComponent implements OnInit{

  entObj = new Cest()
  public lista: any[] = []
  form: UntypedFormGroup;
  usuario: any;
  id: any;

  modalPesquisaNcm = false;
  ncmParcialParaPesquisar = undefined;

    constructor(private fb: UntypedFormBuilder,public route: ActivatedRoute, private networkService: NetworkService, private router: Router, private messageService: MessageService, private dadosDefaultService: DadosDefaultService) {
      this.form = Formulario.createForm(this.entObj, this.fb)
    }

    ngOnInit() {
        this.route.paramMap.subscribe(params => {
          this.id = params.get('id');
            if (this.id) {
              this.networkService.buscar('Cest', this.id, '', URL_BASE).subscribe(value => {
                const data = Formulario.prepareValueToForm(this.entObj, value);
                Object.keys(data).forEach(key => this.form.controls[key].setValue(data[key]))
              })
            }
        })
    }

    verificaNcmValido(e: any) {
        if (e.key !== 'Enter' && e.type !== 'blur' || this.form.get('Ncms')?.value === '') return
        const ncm = this.form.get('Ncms')?.value
        this.dadosDefaultService.verificaNcmValido(ncm).subscribe(res => {
        }, error1 => {
            this.ncmParcialParaPesquisar = ncm
            this.messageService.add({severity: 'error', summary: 'Ncm Invalido'})
            this.modalPesquisaNcm = true
        })
    }

    processarFormulario(){
      const data = Formulario.parseForm(this.entObj, Object.assign(this.form.value));
      this.route.url.subscribe(v => {
        if(v[0].path == 'editar-cest'){
          this.networkService.atualizar(URL_BASE, 'Cest', data).subscribe(value => {
            this.messageService.add(Util.pushSuccessMsg("Edição feita com sucesso!"))
            this.router.navigate(['cest'])
          })
        }
        if(v[0].path == 'incluir-cest'){
          this.networkService.salvarPost(URL_BASE, 'Cest', data).subscribe(value => {
            this.messageService.add(Util.pushSuccessMsg("Cadastro feito com sucesso!"))
            this.router.navigate(['cest'])
          })
        }
      })
    }

    cancelar(){
      this.router.navigate(['cest']);
    }
}
